import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

const WarningIcon = ({ color = '#F1524B', size = '14', ...props }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    viewBox="0 0 16 15"
    {...props}
  >
    <path
      d="M7.044.55L.278 12.955C-.285 14.001-.046 15 1.476 15h12.88c1.525 0 1.761-.999 1.198-2.044L8.65.583c-.14-.28-.343-.587-.775-.583-.458.009-.686.27-.83.55zM7.5 5h1.667v5.833H7.5V5zm0 6.667h1.667v1.666H7.5v-1.666z"
      fill={color}
    />
  </svg>
);

WarningIcon.propTypes = propTypes;

export default WarningIcon;
